var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as moment from 'moment';
import { BaseEntity, MemoizeGetters, Transform, toEntity } from './base';
import { TruckModel } from './truck';
export var ShiftName;
(function (ShiftName) {
    ShiftName["Day"] = "day";
    ShiftName["Morning"] = "morning";
    ShiftName["Night"] = "night";
    ShiftName["LateNight"] = "late_night";
})(ShiftName || (ShiftName = {}));
export const MIN_REQUEST_WINDOW = 4;
let ShiftModel = ShiftModel_1 = class ShiftModel extends BaseEntity {
    get formattedTitle() {
        return `All ${this.title} (${ShiftModel_1.timeStringForHour(this.startTime.hour)}-${ShiftModel_1.timeStringForHour(this.endTime.hour)})`;
    }
    get shiftAvailableToday() {
        let today = moment();
        if (today.day() === this.dayIndex) {
            let currentHour = today.hour();
            return this.endTime.hour - currentHour > MIN_REQUEST_WINDOW;
        }
        return true;
    }
    static defaultStartTime(window) {
        switch (window) {
            case ShiftName.Day:
                return { hour: 9, minute: 0 };
            case ShiftName.Morning:
                return { hour: 5, minute: 0 };
            case ShiftName.Night:
                return { hour: 18, minute: 0 };
            case ShiftName.LateNight:
                return { hour: 0, minute: 0 };
            default:
                return { hour: 9, minute: 0 };
        }
    }
    static defaultEndTime(window) {
        switch (window) {
            case ShiftName.Day:
                return { hour: 17, minute: 0 };
            case ShiftName.Morning:
                return { hour: 9, minute: 0 };
            case ShiftName.Night:
                return { hour: 23, minute: 0 };
            case ShiftName.LateNight:
                return { hour: 5, minute: 0 };
            default:
                return { hour: 17, minute: 0 };
        }
    }
    static timeStringForHour(hour) {
        let ampmString = hour <= 11 ? 'am' : 'pm';
        let hourString = hour <= 12 ? hour : hour - 12;
        return hourString + ampmString;
    }
};
__decorate([
    Transform(toEntity(TruckModel)),
    __metadata("design:type", TruckModel)
], ShiftModel.prototype, "truck", void 0);
ShiftModel = ShiftModel_1 = __decorate([
    MemoizeGetters
], ShiftModel);
export { ShiftModel };
var ShiftModel_1;
//# sourceMappingURL=shift.js.map


// WEBPACK FOOTER //
// ./src/models/shift.ts.pre-build-optimizer.js